import React from 'react';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { RiFileExcel2Line } from "react-icons/ri";

const ExportExcel = (props) => {
    const fileType = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8`;
    const fileExtension = '.xlsx';

    const exportToExcel = async () => {
        const excelData = props.getExcelData(); // <-- Call the function HERE when user clicks
        if (!excelData || excelData.length === 0) {
            console.warn('No data to export');
            return;
        }

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, props.fileName + fileExtension);
    };

    return (
        <>
            <RiFileExcel2Line
                style={{ backgroundColor: 'transparent', color: '#21A366' }}
                size={30}
                onClick={exportToExcel}
            />
        </>
    );
};

export default ExportExcel
